export default __webpack_public_path__ + "static/media/line.bc18b602.gif";